import { render, staticRenderFns } from "./Member.vue?vue&type=template&id=703f1c17&scoped=true&"
import script from "./Member.vue?vue&type=script&lang=js&"
export * from "./Member.vue?vue&type=script&lang=js&"
import style0 from "./Member.vue?vue&type=style&index=0&id=703f1c17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f1c17",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
